export const breakpointsNumber = {
  mobile: 320,
  wideMobile: 480,
  tablet: 768,
  computer: 992,
  largeTablet: 1024,
  largeMonitor: 1440,
  widescreenMonitor: 1920
};

let breakpoints = {};
Object.keys(breakpointsNumber).forEach(
  key => (breakpoints[key] = `${breakpointsNumber[key]}px`)
);

export default breakpoints;
